import { BdsActionBar, BdsButtonGroup, BdsRollupButton, BdsText } from "@buildertrend/components";

import {
    BTConfirm,
    BTConfirmContent,
    BTConfirmFooter,
    BTConfirmHeader,
} from "commonComponents/btWrappers/BTConfirm/BTConfirm";

interface IResetSelectionOptionConfirmDialogProps {
    visible: boolean;
    selectionOptionCount: number;
    inSelectionOptionGroup: boolean;
    onConfirm: () => Promise<void>;
    onCancel: () => void;
}

export function ResetSelectionOptionConfirmDialog({
    visible,
    selectionOptionCount,
    inSelectionOptionGroup,
    onConfirm,
    onCancel,
}: Readonly<IResetSelectionOptionConfirmDialogProps>) {
    const actionVerb = "Recall";
    const actionGerund = "Recalling";

    const getModalTitle = () => {
        if (selectionOptionCount === 1) {
            return `${actionVerb} selection option`;
        }
        return `${actionVerb} ${selectionOptionCount} selection options`;
    };

    return (
        <BTConfirm visible={visible}>
            <BTConfirmHeader>
                <BdsText size="distinct-md" text={getModalTitle()} />
            </BTConfirmHeader>
            <BTConfirmContent className="margin-top-md margin-left-zero">
                <BdsText size="normal-md">
                    {actionGerund}{" "}
                    {selectionOptionCount > 1 ? "these selection options" : "this selection option"}{" "}
                    will{" "}
                    {inSelectionOptionGroup
                        ? "impact your allowance remaining amount"
                        : "decrease your total client price and update your budget"}
                </BdsText>
            </BTConfirmContent>
            <BTConfirmFooter className="margin-bottom-md">
                <BdsActionBar
                    testid="resetSelectionOptionActionBar"
                    id="resetSelectionOptionActionBar"
                >
                    <BdsButtonGroup
                        id="resetSelectionOptionButtonGroup"
                        testid="resetSelectionOptionButtonGroup"
                        menuTestid="resetSelectionOptionButtonMenu"
                        rollupTestid="resetSelectionOptionRollupMenu"
                        flexAlign="end"
                        grow
                    >
                        <BdsRollupButton
                            id="cancelButton"
                            value="cancelButton"
                            testid="cancelButton"
                            text="Cancel"
                            displayType="secondary"
                            onClick={onCancel}
                        />
                        <BdsRollupButton
                            id="confirmButton"
                            testid="confirmButton"
                            onClick={() => void onConfirm()}
                            text={actionVerb}
                            value="reset"
                            displayType="primary"
                        />
                    </BdsButtonGroup>
                </BdsActionBar>
            </BTConfirmFooter>
        </BTConfirm>
    );
}
